import { LicenseInfo } from '@mui/x-license';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import AppContainer from 'components/app/AppContainer';

import ThemeSetup from './components/app/ThemeSetup';
import { store } from './components/app/redux/index';

import './styles/index.css';

LicenseInfo.setLicenseKey(
  //'10782664b2a14c5ee2d689b47d6dba2aTz05NjAzNSxFPTE3NTUxNTExNjMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==',
  'cd48f2e3ca0f4e21386d49da4efddc3dTz0xMTQ0MDksRT0xNzgxOTEzNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=',
);

export const App: React.FC = () => {
  return (
    <ReduxProvider store={store}>
      <Router>
        <ThemeSetup>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AppContainer />
          </QueryParamProvider>
        </ThemeSetup>
      </Router>
    </ReduxProvider>
  );
};
